import React from "react"
import {Route, Routes} from "react-router-dom";
import LoginPage from "./LoginPage";
import LoginPage2 from "../LoginPage/v2";

const LoginRouter = () => {

    return(
        <Routes>
            <Route path={"/"} element={<LoginPage2/>}/>
            <Route path={"/login"} element={<LoginPage2/>}/>
            <Route path="*" element={<LoginPage2 />} />
        </Routes>
    )
}
export default LoginRouter
